
<script>
export default {
    render: () => ({}),
    mounted(){
        this.$router.push('/help-support')
    }
}
</script>